import { fetchJSON } from '@hc-frontend/utils'
import { API_PIVOTHEALTH } from 'core/constants/endpoints'
import parseResponse from './parseResponse'

export function getCompliance({
  products,
  stateAcronym,
  agentId,
  notParse,
  multiCarrier,
  planIds
}: ComplianceRequestParams): Promise<Compliance> {
  const addParams = [
    multiCarrier != null ? `multiCarrier=${multiCarrier}` : '',
    planIds && planIds.length > 0 ? `planIds=${planIds.join(',')}` : ''
  ].filter(Boolean)

  return fetchJSON(
    `${API_PIVOTHEALTH}/compliance/v3/compliance?productLines=${products}&state=${stateAcronym}&agentId=${agentId}${
      addParams.length > 0 ? `&${addParams.join('&')}` : ''
    }`
  )
    .then(request => request.parsedBody)
    .then(res => {
      if (notParse) {
        return res as Compliance
      }
      return parseResponse(res)
    })
}
